import React from 'react';
import { FormattedMessage } from 'react-intl';

// constants
import { USER_FILTER_FIELD_NAMES } from '../../../../../../constraints';

// Components
import { ControlledTextField } from '../../../../../../components/ControlledTextField';
import { FieldLabel } from '../../../../../../components/Form';

const TextIdField = ({ name = USER_FILTER_FIELD_NAMES.ID }) => {
  return (
    <>
      <FieldLabel>
        <FormattedMessage id="ID" defaultMessage="ID" />
      </FieldLabel>
      <ControlledTextField name={name} />
    </>
  );
};

export default TextIdField;
